import { create } from 'zustand';

export type AutoPlayState = 'idle' | 'running' | 'paused';

interface GenerationStore {
  autoPlayState: AutoPlayState;
  currentSceneId: string | null;
  completedCount: number;
  totalCount: number;
  inFlightSceneIds: Set<string>;

  startAutoPlay: (totalCount: number) => void;
  setCurrent: (sceneId: string | null) => void;
  incrementCompleted: () => void;
  pauseAutoPlay: () => void;
  resumeAutoPlay: () => void;
  stopAutoPlay: () => void;
  markInFlight: (sceneId: string) => void;
  clearInFlight: (sceneId: string) => void;
}

export const useGenerationStore = create<GenerationStore>((set) => ({
  autoPlayState: 'idle',
  currentSceneId: null,
  completedCount: 0,
  totalCount: 0,
  inFlightSceneIds: new Set(),

  startAutoPlay: (totalCount) =>
    set({ autoPlayState: 'running', completedCount: 0, totalCount }),
  setCurrent: (currentSceneId) => set({ currentSceneId }),
  incrementCompleted: () =>
    set((s) => ({ completedCount: s.completedCount + 1 })),
  pauseAutoPlay: () => set({ autoPlayState: 'paused' }),
  resumeAutoPlay: () => set({ autoPlayState: 'running' }),
  stopAutoPlay: () =>
    set({
      autoPlayState: 'idle',
      currentSceneId: null,
      completedCount: 0,
      totalCount: 0,
    }),
  markInFlight: (sceneId) =>
    set((s) => {
      const next = new Set(s.inFlightSceneIds);
      next.add(sceneId);
      return { inFlightSceneIds: next };
    }),
  clearInFlight: (sceneId) =>
    set((s) => {
      const next = new Set(s.inFlightSceneIds);
      next.delete(sceneId);
      return { inFlightSceneIds: next };
    }),
}));
